<template>
	<div class="u-relative">
		<el-upload
			v-if="!isHideUpload"
			:action="action"
			:class="{hide: isHideUpload}"
			:file-list="fileList"
			:headers="headers"
			:limit="limitCount"
			:on-change="onChange"
			:on-preview="onPreview"
			:on-remove="onRemove"
			:on-success="onSuccess"
			:show-file-list="false"
			drag
			list-type="picture-card">
			<!--      <div >将文件拖到此处，或<em>点击上传</em></div>-->

			<!--      <el-icon class="el-icon-plus u-font-md"></el-icon>-->

			<div class="el-upload__text" style="white-space: pre-line">
				<span class="u-font-18 u-c-gray u-m-t-10" style="height: 20px !important">上传营业执照</span>
				<br />
				<span class="u-font-18 u-c-gray" style="height: 20px !important">可识别企业信息</span>
			</div>

			<div slot="tip" class="el-upload__tip">请上传大小不超过2Mb的jpg/png文件</div>
		</el-upload>
		<div v-else class="upload-size">
			<img :border="6" :src="bigImgUrl" alt="" height="178px" width="178px" />
		</div>

		<el-dialog :visible.sync="isShowBigImg" append-to-body>
			<img :src="bigImgUrl" alt="" width="100%" />
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'
import store from '@/store'

export default {
	name: 'customUpload',
	mixins: [],
	components: {},
	props: {
		action: {
			type: String,
			default: '/dist/distInsure/uploadFile',
		},
	},
	data() {
		return {
			headers: {
				Authorization: 'Bearer ' + store.getters.access_token,
			},
			isHideUpload: false,
			fileList: [],
			isShowBigImg: false,
			bigImgUrl: '',
			limitCount: 1,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		onPreview(file) {
			this.bigImgUrl = file.url
			this.isShowBigImg = true
		},
		onSuccess(res, file) {
			this.bigImgUrl = URL.createObjectURL(file.raw)
		},
		onRemove(file, fileList) {
			this.fileList = []
			this.isHideUpload = fileList.length >= this.limitCount
		},
		onChange(file, fileList) {
			this.fileList = fileList
			this.isHideUpload = fileList.length >= this.limitCount
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .hide .el-upload--picture-card {
	display: none;
}

::v-deep .el-upload-dragger {
	width: 180px;
}

::v-deep .el-upload--picture-card {
	width: 180px;
	height: 180px;
	border: none;
}

::v-deep .el-upload-dragger {
	width: 150px;
	border: 1px dashed #d9d9d9 !important;

	&:hover {
		border: 1px dashed #4f96e5 !important;
	}
}

::v-deep .el-upload-dragger .el-upload__text {
	height: 180px !important;
}
</style>
